import React from 'react'
import PropTypes from 'prop-types'

const Table = ({ children, classes }) => (
  <table className={classes}>
    {children}
  </table>
)

Table.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
}

export default Table
